import type { CallbackCompleteData } from '__generated__/api/unauth';

import { ENV, SUB_DOMAIN } from '@/constants';
import type { OsType } from '@/stores/DeviceStore';

/** API 스펙에서 보장하는 BE 콜백 경로 (변경 시 타입 에러 발생) */
const DONATION_COMPLETE_PATH: CallbackCompleteData['url'] =
  '/wello/v2/allows/home-love/donation/complete';

/**
 * BE 결제 완료 처리용 returnUrl 생성
 * PG 결제 완료 후 BE가 donationComplete를 처리하고 FE로 302 리다이렉트
 */
export const createDonationReturnUrl = ({
  subDomain,
  osType,
}: {
  subDomain?: SUB_DOMAIN | null;
  osType?: OsType;
}): string => {
  const url = new URL(`${ENV.NEXT_PUBLIC_API_DOMAIN}${DONATION_COMPLETE_PATH}`);

  url.searchParams.set('subDomain', subDomain ?? SUB_DOMAIN.WELLO);

  if (osType) {
    url.searchParams.set('osType', osType);
  }

  return url.toString();
};
